import { httpService } from '@/services/shared/http';
import { LoginPayload, LoginResponse } from '@/types';

export const loginUser = async (credentials: LoginPayload): Promise<LoginResponse> => {
  try {
    const response = await httpService.post<LoginResponse, LoginPayload>(
      'login',
      credentials,
      undefined,
      false
    );
    
    return response;
      
  } catch (error) {
    throw new Error('Login fallito: ');
  }
};